module.exports = __webpack_public_path__ + "static/babybemine-a573af09fe734b6dc7a43736bb10c33f.png";